import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import  './ChatPopup.scss';
import icon from '../../../assets/img/chat.png'
import AadiHome from '../AIChat/AadiHome';
export default function ChatPopup() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div variant="outlined" onClick={handleClickOpen}>
        <img width={40} src={icon} alt='icon'/>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id='AadiChat'
      >
        <DialogContent>
         <AadiHome/>
        </DialogContent>
     
      </Dialog>
    </React.Fragment>
  );
}